import { render, staticRenderFns } from "./TextHalf.vue?vue&type=template&id=5cb9a913&"
import script from "./TextHalf.vue?vue&type=script&lang=js&"
export * from "./TextHalf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports